module.exports = __webpack_public_path__ + "img/6_13.412d2c11.png";